import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import PropTypes from 'prop-types'
import Button from '../../../button'
import { useIsAuthenticated } from '../../../../hooks/use-is-authenticated'
import { useWelcomeBack } from './hooks/use-welcome-back'
import { segmentTrackClickOnWelcomeBackModal } from '../../../../segment/segment-track'
import ActionTypes from '../../../../actions/types'
import styles from './index.css'

/**
 * Shows the WelcomeBack modal after login for users who are unsubscribed
 * or have not completed the required account details during the sign-up journey
 *
 * Users can add a plan or finish signing up from this modal
 * Clicking "Back to browse" will display the WelcomeBack banner and close this modal
 */
const WelcomeBack = ({ onRequestClose }) => {
  const isAuthenticated = useIsAuthenticated()
  const dispatch = useDispatch()
  const {
    accountData,
    headerAndCopy,
    confirmText,
    handleConfirm
  } = useWelcomeBack()

  // Close modal if user is not authenticated
  useEffect(() => {
    if (!isAuthenticated) onRequestClose()
  }, [isAuthenticated, onRequestClose])

  // Close modal if user already has a subscription
  useEffect(() => {
    if (accountData?.account?.subscription?.currentSubscription) {
      onRequestClose()
    }
  }, [accountData, onRequestClose])

  const onClickOk = () => {
    // Add segment data analytics for winback user
    segmentTrackClickOnWelcomeBackModal({
      choosePlan: true,
      backToBrowse: false
    })

    dispatch({ type: ActionTypes.SET_SHOW_WELCOME_BACK_BANNER, payload: false })
    handleConfirm()
  }

  const onClickClose = () => {
    // Add segment data analytics for winback user
    segmentTrackClickOnWelcomeBackModal({
      choosePlan: false,
      backToBrowse: true
    })

    dispatch({ type: ActionTypes.SET_SHOW_WELCOME_BACK_BANNER, payload: true })
    onRequestClose()
  }

  const renderHeaderAndCopy = () => {
    return (
      headerAndCopy.map((dialog, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <div key={index}>
          <h2 className={styles.header}>
            {dialog.header}
          </h2>
          <p className={styles.copy}>
            {dialog.msg}
          </p>
        </div>
      ))
    )
  }

  return (
    <div className={styles.wrapper}>
      {renderHeaderAndCopy()}
      <div className={styles.buttonRow}>
        <Button
          darkBGSecondary
          wrapperClassName={styles.buttonWrapper}
          className={styles.button}
          onClick={onClickClose}
          text="Back to browse"
        />
        <Button
          onClick={onClickOk}
          wrapperClassName={styles.buttonWrapper}
          className={styles.button}
          text={confirmText}
        />
      </div>
    </div>
  )
}

WelcomeBack.propTypes = {
  onRequestClose: PropTypes.func.isRequired
}

export default WelcomeBack
